// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5091":"4e378be7","7323":"760d05b4"}[chunkId] + ".chunk.css";
};